import { fetchInappPostReminderHowItWorks } from '@/assets/ts/apiManagement'

export default class PostReminderHowItWorksView extends HTMLElement {
	promise: Promise<string>

	constructor() {
		super()
		const shadow = this.attachShadow({ mode: 'open' })

		this.promise = fetchInappPostReminderHowItWorks().then((res: any) => {
			const appendStyle = `
          <style>
            h1 {
              display: none;
            }
          </style>
        `

			const htmlMarkupFormat = res.data
				.replace('</head>', `${appendStyle}</head>`)
				.replace('<body', '<div')
				.replace('</body>', '</div>')
				.replace(/<a/gi, '<a target="_blank"')

			shadow.innerHTML = htmlMarkupFormat

			const re = '\\<h1\\>(.+)\\<\\/h1\\>'
			const titleMatch = res.data.match(re)
			return titleMatch ? titleMatch[1] : ''
		})
	}
}
